import * as React from "react"
const SvgReplyAll = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m4.825 11.714 3.9 3.9q.3.3.288.7a1 1 0 0 1-.313.7q-.3.276-.7.288a.92.92 0 0 1-.7-.288l-4.6-4.6a.9.9 0 0 1-.212-.325 1.1 1.1 0 0 1-.063-.375q0-.2.063-.375a.9.9 0 0 1 .212-.325l4.6-4.6a.93.93 0 0 1 .688-.275q.412 0 .712.275.3.3.3.713 0 .412-.3.712zm6 1 2.9 2.9q.3.3.287.7-.012.4-.312.7-.3.276-.7.288a.92.92 0 0 1-.7-.288l-4.6-4.6a.9.9 0 0 1-.212-.325 1.1 1.1 0 0 1-.063-.375q0-.2.063-.375a.9.9 0 0 1 .212-.325l4.6-4.6a.93.93 0 0 1 .688-.275q.412 0 .712.275.3.3.3.713 0 .412-.3.712l-2.875 2.875H17q2.075 0 3.538 1.463T22 15.714v3a.97.97 0 0 1-.288.713.97.97 0 0 1-.712.287.97.97 0 0 1-.712-.287.97.97 0 0 1-.288-.713v-3q0-1.25-.875-2.125A2.9 2.9 0 0 0 17 12.714z" />
  </svg>
)
export default SvgReplyAll
